import { useEffect, useState } from 'react';
import { HEADER_HEIGHT_PX } from '../utils/moduleConfig';

/**
 * Tracks the live bottom edge of `.module-header` so full-screen module overlays
 * (Incoming Stock, Preorders, etc.) sit flush below the shared header.
 */
export function useAppHeaderOffset(active = true) {
  const [offsetPx, setOffsetPx] = useState(HEADER_HEIGHT_PX);

  useEffect(() => {
    if (!active) return undefined;

    let observedHeader = null;
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(() => sync()) : null;

    const sync = () => {
      const header = document.querySelector('.module-header');
      if (!header) return;
      if (header !== observedHeader) {
        if (observedHeader) observer?.unobserve(observedHeader);
        observer?.observe(header);
        observedHeader = header;
      }
      const bottom = Math.round(header.getBoundingClientRect().bottom);
      if (bottom > 0) {
        setOffsetPx(bottom);
        document.documentElement.style.setProperty('--app-header-offset', `${bottom}px`);
      }
    };

    sync();
    window.addEventListener('resize', sync);

    return () => {
      if (observedHeader) observer?.unobserve(observedHeader);
      observer?.disconnect();
      window.removeEventListener('resize', sync);
    };
  }, [active]);

  return offsetPx;
}
